<template>
  <item-demo v-if="isSimulation && !isMenu" :style="{ 'background-color': BGColorContent }" />
  <div v-else :style="{ 'background-color': customBGColorContent ? customBGColorContent : BGColorContent }">    
    <div 
      v-for="item in isSimulation && editTMP && id === editTMP.ID && contents ? contents : apiContents"
      :key="`content${item.ID}`"
    >
      <items
        :item="item"
        :menuID="id"
        :isMobile="true"
        :customTextColorContent="customTextColorContent"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import constants from '@/constants'
  import Items from '@/components/Items'
  import dview from '@/services/dview-service'
  import ItemDemo from './items/Demo'
  export default {
    name: 'CustomContent',
    components: {
      Items,
      ItemDemo
    },
    props: {
      id: {
        type: String,
        required: true,
        default: null
      },
      customBGColorContent: {
        type: String,
        required: false,
        default: null
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      apiContents: []
    }),
    computed: {
      ...mapState('app',['forceRefreshOnSave','editTMP', 'contents', 'BGColorContent', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      title () { return 2 },
      isTest () {
        return this.$route.query.test
      },
    },
    watch: {
      id: {
        handler: function (newValue) {
          this.getContent(newValue)
        },
        deep: true
      },
      'forceRefreshOnSave.lmd' () {
        if (this.forceRefreshOnSave.id === this.id) {
          this.getContent(this.id)
        }
      },
    },
    mounted () {
      this.getContent(this.id)
    },
    methods: {
      getContent(id) {
        //api.getAll(`contents`, false, null, null, null, id).then(response => {
        api.getAll(`contents`, false, null, null, null, id.concat(this.isTest ? '/test': '')).then(response => {
          this.apiContents = response.map(item => {
            item.IsActive = dview.isActive(item)
            return (item)
          }).filter(x => x.IsActive.date && x.IsActive.time || this.isSimulation)
          // console.log('hhh', response.filter( x => dview.isActive(x).time).length)
          // this.apiContents = response
        })
      }
    }
  }
</script>
<style scoped>
</style>
